<template>

    <h2>Account Details</h2>

    <Form @submit="onSubmit" :validation-schema="schema">
        <div class="row">
            <div class="col-24 col-xl-12">
                <div class="form-group row mb-4">
                    <div class="col-12 col-xl-6 mb-3 mb-xxl-0">
                        <div class="details-label">
                            Title
                        </div>

                        <Field name="title" as="select" class="form-select " v-model="currentUser.title" style="min-height: 56px">
                            <option v-for="title in titles" v-bind:key="title.OperaCode" v-bind:value="title.OperaCode">{{title.DisplayName}}</option>
                        </Field>
                        <ErrorMessage name="title" class="error-message" />

                    </div>
                    <div class="col-24 col-xl-9 mb-3 mb-xxl-0">
                        <div class="details-label">
                            First Name
                        </div>
                        <Field name="firstName" class="form-control" v-model="currentUser.firstName"></Field>
                        <ErrorMessage name="firstName" class="error-message" />

                    </div>

                    <div class="col-24 col-xl-9">
                        <div class="details-label">
                            Last Name
                        </div>
                        <Field name="lastName" class="form-control" v-model="currentUser.lastName"></Field>
                        <ErrorMessage name="lastName" class="error-message" />

                    </div>
                </div>

                <div class="form-group row mb-4">
                    <div class="col-24 ">
                        <div class="details-label">
                            Email
                        </div>
                        <Field name="emailAddress" class="form-control" v-model="currentUser.email"></Field>
                        <ErrorMessage name="emailAddress" class="error-message" />
                    </div>

                </div>


                <div class="form-group row mb-4">
                    <div class="col-24 ">
                        <div class="details-label">
                            Telephone
                        </div>
                        <Field name="telephone" class="form-control" type="tel" v-model="currentUser.telephone"></Field>
                        <ErrorMessage name="telephone" class="error-message" />
                    </div>

                </div>


                <div v-if="isInOpera">
                    <div class="form-group row mb-4">
                        <div class="col-24">
                            <div class="details-label">
                                Address
                            </div>

                            <Field name="address.country" as="select" class="form-select" v-model="selectedCountry"  style="min-height: 56px">
                                <option v-for="country in countries" v-bind:key="country.OperaCode" v-bind:value="country.OperaCode">{{country.DisplayName}}</option>
                            </Field>
                            <ErrorMessage name="address.country" class="error-message" />

                        </div>
                    </div>

                    <div v-if="selectedCountry == 'GB'">

                        <div class="form-group row mb-2 ">

                            <div class="col-24">
                                <button type="button" class="btn btn--gold btn--manual-address" v-on:click="lookingUpAddressEntry = true">
                                    Look up address
                                </button>
                            </div>
                        </div>

                        <div v-if="lookingUpAddressEntry" class="form-group row mb-4 flex-row g-0">

                            <div class="col-xl-12">
                                <input type="text" class="form-control  " placeholder="Enter postcode" v-model="searchPostcode" />
                            </div>
                            <button class="btn btn--gold col-xl-12" type="button" v-on:click="onLookupAddress">Find Address</button>
                        </div>

                        <div v-if="addressList">

                            <div class="form-group row mb-4">
                                <div class="col">
                                    <select class="form-select" v-on:change="onSelectAddress" v-model="selectedAddress">
                                        <option disabled selected v-bind:value="null">Please select...</option>
                                        <option v-bind:value="address" v-for="address in addressList">
                                            {{address.line1}} {{address.locality}}
                                        </option>
                                    </select>

                                </div>
                            </div>
                        </div>



                    </div>



                    <div v-show="localAddressSet">
                        <div class="form-group row mb-4">
                            <div class="col-24">
                                <div class="details-label">
                                    First line of address
                                </div>

                                <Field name="address.line1" class="form-control" v-model="localAddress.line1"></Field>
                                <ErrorMessage name="address.line1" class="error-message" />

                            </div>
                        </div>


                        <div class="form-group row mb-4">
                            <div class="col-24">
                                <div class="details-label">
                                    Second line of address (optional)
                                </div>

                                <Field name="address.line2" class="form-control" v-model="localAddress.line2"></Field>
                                <ErrorMessage name="address.line2" class="error-message" />

                            </div>
                        </div>

                        <div class="form-group row mb-4">
                            <div class="col-xl-18">
                                <div class="details-label">
                                    City
                                </div>
                                <Field name="address.city" class="form-control" v-model="localAddress.city"></Field>
                                <ErrorMessage name="address.city" class="error-message" />

                            </div>
                        </div>


                        <div class="form-group row mb-4">
                            <div class="col-xl-12">
                                <div class="details-label">
                                    Postcode
                                </div>
                                <Field name="address.postCode" class="form-control" v-model="localAddress.postCode"></Field>
                                <ErrorMessage name="address.postCode" class="error-message" />

                            </div>
                        </div>
                    </div>




                </div>





                <div class="form-group row mb-4">
                    <div class="col-16">
                        <div class="details-label">
                            Birthday
                        </div>

                        <v-date-picker class="inline-block h-full" v-model="currentUser.birthday">
                            <template v-slot="{ inputValue, togglePopover }">
                                <div class="flex items-center" @click="togglePopover()">
                                    <input v-bind:value="inputValue"
                                           class="form-control search-date calendar"
                                           readonly />


                                </div>
                            </template>
                        </v-date-picker>
                        <ErrorMessage name="birthday" class="error-message" />

                        <Field type="hidden"
                               v-model="currentUser.birthday"
                               name="birthday"></Field>

                    </div>

                </div>

                <div class="form-group row mt-5 mb-5">
                    <div class="col-24">
                        <div class="btn-container-start">

                            <router-link class="account-change-password" v-bind:to="{name : 'account_change_password'}">
                                Change your password
                            </router-link>
                        </div>
                    </div>
                </div>


                <div class="form-group row">
                    <div class="col-24">
                        <div class="btn-container-start">
                            <div class="d-flex flex-row">
                                <button v-bind:disabled="isLoading" class="btn btn--slate-blue" type="submit">Update</button>
                                <div v-if="isLoading" style="max-height: 66px; margin-left: 10px;">
                                    <loader></loader>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Form>

</template>

<script>
    import { Field, Form, ErrorMessage } from "vee-validate";
    import * as yup from "yup";
    import "yup-phone";
    import { accountStore } from '../store/index';
    import addressapi from '@/shared/api/address';
    import Loader from '@/shared/components/Loader.vue';

    export default {
        name: 'AccountDetails',
        mounted() {

            if (this.configuration == null) {
                accountStore.dispatch("getConfiguration");
            }
            if (this.userProfile != null) {
                this.currentUser = {
                    firstName: this.userProfile.FirstName,
                    lastName: this.userProfile.LastName,
                    telephone: this.userProfile.Telephone,
                    email: this.userProfile.EmailAddress,
                    title: this.userProfile.Title,
                    birthday: this.userProfile.Birthdate != null ? new Date(this.userProfile.Birthdate) : null,
                }
                if (this.userProfile.Address != null) {
                    this.localAddress.line1 = this.userProfile.Address.Line1;
                    this.localAddress.line2 = this.userProfile.Address.Line2;
                    this.localAddress.country = this.userProfile.Address.Country;
                    this.localAddress.city = this.userProfile.Address.City;
                    this.localAddress.postCode = this.userProfile.Address.PostCode;
                    this.localAddressSet = true;
                }
            }

        },
        components: {
            Field,
            Form,
            ErrorMessage,
            Loader
        },
        computed: {
            configuration() {
                return accountStore.getters.accountConfiguration;
            },
            titles() {
                if (this.configuration != null) {
                    return this.configuration.Titles;
                }
                return [];
            },
            userProfile() {
                return accountStore.getters.userProfile;
            },
            isInOpera() {
                return this.userProfile.RegisteredInOpera;
            },
            countries() {
                return accountStore.getters.accountConfiguration.Countries;
            },
        },
        data() {



            let schema = null;

            if (accountStore.getters.userProfile.RegisteredInOpera) {
                schema = yup.object().shape({
                    title: yup.string().required().label("Title"),
                    firstName: yup.string().required().label("First name"),
                    lastName: yup.string().required().label("Last name"),
                    emailAddress: yup.string().required().email().label("Email address"),
                    telephone: yup.string().required().phone().label("Telephone"),
                    address: yup.object().shape({
                        line1: yup.string().required().label("Address line 1"),
                        line2: yup.string().notRequired().nullable().label("Address line 2"),
                        city: yup.string().required().label("City"),
                        country: yup.string().required().label("Country"),
                        postCode: yup.string().required().label("Postcode")
                    }),
                    birthday: yup.string().nullable().label("Birthday")
                });
            }
            else {
                schema = yup.object().shape({
                    title: yup.string().required().label("Title"),
                    firstName: yup.string().required().label("First name"),
                    lastName: yup.string().required().label("Last name"),
                    emailAddress: yup.string().required().email().label("Email address"),
                    telephone: yup.string().required().phone().label("Telephone"),

                    birthday: yup.string().nullable().label("Birthday")
                });

            }

            let currentUser = {
                firstName: null,
                lastName: null,
                telephone: null,
                email: null,
                title: null,
                birthday: null,
            }

            return {
                isLoading: false,
                currentUser,
                schema,
                lookingUpAddressEntry: false,
                addressList: null,
                searchPostcode: null,
                selectedCountry: 'GB',
                selectedAddress: null,
                localAddressSet: false,
                localAddress: {
                    line1: '',
                    line2: '',
                    city: '',
                    country: '',
                    postCode: ''
                },

            }
        },
        methods: {
            onSubmit(values) {
                this.isLoading = true;
                accountStore.dispatch("update", values).then(() => {

                    this.isLoading = false;
                });
            },
            onSelectAddress: function () {

                if (this.selectedAddress != null) {

                    this.localAddress.line1 = this.selectedAddress.line1;
                    this.localAddress.line2 = this.selectedAddress.locality;
                    this.localAddress.city = this.selectedAddress.city;
                    this.localAddress.postCode = this.searchPostcode.toUpperCase();
                }
                this.addressList = null;
            },
            onLookupAddress: function () {
                var payload = {
                    postalCode: this.searchPostcode
                };

                addressapi.lookupAddress(payload, t => {
                    this.addressList = t.addresses;
                });
            },
        }
    }
</script>

<style>

    .account-change-password {
        font-weight: bold;
        font-size: 14px;
        text-transform: uppercase;
        position: relative;
    }

        .account-change-password:after {
            position: absolute;
            width: 100%;
            bottom: -5px;
            background: #000;
            height: 2px;
            width: 100%;
            left: 0;
            right: 0;
            content: '';
            display: block;
        }
</style>
